module.exports = __webpack_public_path__ + "static/media/lokom.f1b04d4a.jpg";